import React, { useState, useEffect } from "react";

import { BrowserRouter } from "react-router-dom";
import { Toast } from "@shopify/app-bridge-react";
import { QueryClient } from "@tanstack/react-query";

import AppSignalWrapper from "./global/AppSignalWrapper.jsx";
import { AppContextProvider } from "./global/appContext.jsx";
import ReactQueryClientProvider from "./global/queryClientProvider.jsx";
import PolarisProvider from "./global/polarisProvider.jsx";
import AppBridgeProvider from "./global/appBridgeProvider.jsx";
import AppWrapper from "./global/appWrapper.jsx";
import AppRoutes from "./global/AppRoutes.jsx";

// Initialize i18n
import "./global/i18n";
import i18n from "./global/i18n";

// Debug Translator Switcher Component


export default function App(props) {
  const [toast, setToast] = useState({ content: null, error: false });

  // Initialize i18n with Shopify locale detection
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const locale = urlParams.get('locale');
    
   // if (locale && locale !== i18n.language) {
    //  i18n.changeLanguage(locale);
   // }
  }, []);

  function setMessage(content, error = false) {
    setToast({ content: content, error: error });
  }

  const toastMarkup = toast.content ? (
    <Toast
      content={toast.content}
      onDismiss={() => {
        setToast({ content: null, error: false });
      }}
      duration={toast.error ? 5000 : 2500}
      error={toast.error}
    />
  ) : null;

  return (
    <PolarisProvider>
      <AppSignalWrapper>
        <BrowserRouter>
          <AppContextProvider {...props} {...{ setMessage }}>
            <ReactQueryClientProvider showDevTools={!props.production}>
              <AppBridgeProvider>
                <AppWrapper toastMarkup={toastMarkup}>
                  <AppRoutes />
                </AppWrapper>
              </AppBridgeProvider>
            </ReactQueryClientProvider>
          </AppContextProvider>
        </BrowserRouter>
      </AppSignalWrapper>
    </PolarisProvider>
  );
}

// import Appsignal from "@appsignal/javascript";
// import { ErrorBoundary } from "@appsignal/react";

// const FallbackComponent = () => <div>Uh oh! There was an error :(</div>;
// const appsignal = new Appsignal({
//   active: true,
//   key: "b3a23111-e61a-4567-94af-043674495ed7",
// });
// <ErrorBoundary
//   instance={appsignal}
//   debug={true}
//   // tags={{ tag: "value" }}
//   fallback={(error) => <FallbackComponent />}
// >
//   ...Code here...
// </ErrorBoundary>;
